module.exports = __webpack_public_path__ + "assets/img/newimglr.093357b5.png";